var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.066 1.932H5.933l-.845 2.225H2.93v1h10.14v-1h-2.158l-.846-2.225Zm-.224 2.225-.465-1.225H6.623l-.465 1.225h3.684Zm1.202 1.957-.587 5.955-.999.999h-2.95l-.999-.998-.553-5.954-.996.09.586 6.315 1.547 1.547h3.78l1.546-1.546.62-6.313-.995-.095ZM7.5 11.686V6.452h1v5.234h-1Z",
    fill: "currentColor"
  })));
};
export default SvgTrash;